import { memo, type ReactNode, type Ref } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { PlannerEmployee } from "@/components/appointmentRequest/assignmentPlanner/assignmentPlan";
import { plannerDepartments } from "@/components/appointmentRequest/assignmentPlanner/employeeFiltering";
import styles from "@/components/appointmentRequest/assignmentPlanner/planner.module.css";

const ALL_DEPARTMENTS = "__all_departments__";
interface Props {
  employees: PlannerEmployee[];
  search: string;
  onSearch: (value: string) => void;
  departments: string[];
  onDepartments: (ids: string[]) => void;
  toggle?: ReactNode;
  autoFocus?: boolean;
  inputRef?: Ref<HTMLInputElement>;
}
export default memo(function PlannerEmployeeSearch(props: Props) {
  const { t } = useTranslation();
  const all = { id: ALL_DEPARTMENTS, name: t("planner.all") };
  const departments = plannerDepartments(props.employees);
  const selected =
    departments.find((entry) => entry.id === props.departments[0]) ?? all;
  return (
    <div className={styles.employeeFilters}>
      <TextField
        className={styles.employeeSearch}
        size="small"
        autoFocus={props.autoFocus}
        inputRef={props.inputRef}
        label={t("planner.search_employees")}
        placeholder={t("planner.search_hint")}
        value={props.search}
        onChange={(event) => props.onSearch(event.target.value)}
      />
      {props.toggle}
      <Autocomplete
        className={styles.departmentFilter}
        disableClearable
        title={selected.name}
        options={[all, ...departments]}
        value={selected}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.name}
        onChange={(_event, value) =>
          props.onDepartments(value.id === ALL_DEPARTMENTS ? [] : [value.id])
        }
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={t("planner.departments")}
          />
        )}
      />
    </div>
  );
});
